import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { apiKey } from "../../../config/config";
import { IoClose } from "react-icons/io5";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print";

function SubscriptionDetails() {
  const customer = JSON.parse(localStorage.getItem("rms-customer"));
  const [data, setData] = useState(null);
  const [selectedSubscription, setSelectedSubscription] = useState(null);

  const cardRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => cardRef.current,
    documentTitle: "Invoice",
  });

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/subscriptions/subscribed`, {
        headers: {
          Authorization: `Bearer ${customer?.token}`,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [customer?.token]);

  const NotSubscribed = (
    <div className="h-full w-full grid place-items-center">
      <div className="text-center">
        <h2 className="text-[2rem] font-medium">Not Subscribed Yet?</h2>
      </div>
      <img src="/assets/items/subscription-img.png" alt="" />
      <Link
        to={"/subscriptions"}
        className="bg-w-btn text-w-btn-text max-w-[15rem] w-full px-2 py-1 rounded mx-auto text-center border-w-border"
      >
        Subscribe Now
      </Link>
    </div>
  );

  const WaitingApproval = (
    <div className="h-full w-full grid place-items-center">
      <div className="text-center">
        <h2 className="text-[2rem] font-medium">Waiting for Approval.</h2>
      </div>
      <img src="/assets/items/subscription-img.png" alt="" />
    </div>
  );

  const Approved = (data) => {
    let totalMeal = 0;
    data.forEach((item) => {
      totalMeal += item.item_qty;
    });
    return (
      <div className="h-full w-full">
        <div className="text-center">
          <h2 className="text-[2rem] font-medium">
            Total Meal: {totalMeal}
          </h2>
        </div>
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-w-border">
          <thead className="text-xs text-white uppercase bg-w-bg">
            <tr>
              <th className="px-6 py-3">Package Name</th>
              <th className="px-6 py-3">Amount</th>
              <th className="px-6 py-3">Total Meal</th>
              <th className="px-6 py-3">Available Meal</th>
              <th className="px-6 py-3">Payment Method</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3">Expiry Date</th>
              <th className="px-6 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index} className="border-b border-b-gray-100">
                <td className="px-6 py-3">{item.heading}</td>
                <td className="px-6 py-3">{item.amount}</td>
                <td className="px-6 py-3">{item.item_qty}</td>
                <td className="px-6 py-3">{item.subscription.item_qty}</td>
                <td className="px-6 py-3">{item.payment.name}</td>
                <td className="px-6 py-3">
                  {item.status === 0 ? "Pending" : "Approved"}
                </td>
                <td className="px-6 py-3">{item.expire_date}</td>
                <td className="px-6 py-3">
                  {item.iS_card === 0 ? (
                    "-"
                  ) : (
                    <button
                      onClick={() => setSelectedSubscription(item)}
                      className="bg-w-bg text-white w-24 px-2 py-1 rounded"
                    >
                      View Card
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {selectedSubscription && (
          <div
            className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-50"
            onClick={() => setSelectedSubscription(null)}
          >
            <div
              className="bg-white p-4 rounded max-w-md w-full relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-2 right-2"
                onClick={() => setSelectedSubscription(null)}
              >
                <IoClose />
              </button>
              <div
                ref={cardRef}
                className="py-6 px-16"
                style={{
                  backgroundImage: "url('/assets/items/sub_card_bg.jpg')",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "38rem",
                  // width: "100%",
                  borderRadius: "0.5rem",
                }}
              >
                <div className="text-white mt-32 space-y-4">
                  <div>
                    <span className="flex justify-between">
                      <h3>Name</h3>
                      <h3>الاسم</h3>
                    </span>
                    <p className="bg-red-400 px-2 py-1 rounded">
                      {selectedSubscription?.customers?.name}
                    </p>
                  </div>
                  <div>
                    <span className="flex justify-between">
                      <h3>Phone Number</h3>
                      <h3>رقم الاشتراك</h3>
                    </span>
                    <p className="bg-red-400 px-2 py-1 rounded">
                      {selectedSubscription?.customers?.phone}
                    </p>
                  </div>
                  <div>
                    <span className="flex justify-between">
                      <h3>Selected Package</h3>
                      <h3>الباقة</h3>
                    </span>
                    <p className="bg-red-400 px-2 py-1 rounded">
                      {selectedSubscription?.heading}
                    </p>
                  </div>
                  <div>
                    <span className="flex justify-between">
                      <h3>Total Meal</h3>
                      <h3>مجموع الوجبات</h3>
                    </span>
                    <p className="bg-red-400 px-2 py-1 rounded">
                      {selectedSubscription?.item_qty}
                    </p>
                  </div>
                </div>
                <div className="flex justify-center">
                  <QRCode
                    value={selectedSubscription?.customers?.phone}
                    className="mx-auto w-24 -mt-8"
                  />
                </div>
              </div>
              <div className="mt-4 flex gap-4 justify-around">
                <button
                  onClick={() => setSelectedSubscription(null)}
                  className="bg-gray-300 px-2 w-20 py-1 rounded"
                >
                  Close
                </button>
                <button
                  onClick={handlePrint}
                  className="bg-w-bg text-white px-2 py-1 w-24 rounded"
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  if (!data) {
    return NotSubscribed; // ✅ no < />
  }

  if (data.success === false) {
    return WaitingApproval; // ✅ no < />
  }

  return Approved(data?.subscription);
}

export default SubscriptionDetails;
